// extracted by mini-css-extract-plugin
export default {"tagList":"tags_tagList__KaJ4P","firstCaption":"tags_firstCaption__3XjdY","tag":"tags_tag__P-7WO"};